import React, { useState } from 'react';
import { FaTruckMoving, FaClipboardCheck, FaMapMarkerAlt, FaChevronDown } from 'react-icons/fa';

function DomesticSameDayService() {
  const [openFAQ, setOpenFAQ] = useState(null);  // To track which FAQ is open

  const domesticServices = [
    {
      service: "Same Day Pickup",
      description: "Need your package picked up today? Our Same Day Pickup service ensures quick and efficient collection from your location, and delivery within the same day.",
      icon: <FaTruckMoving className="w-16 h-16 text-black" />,
    },
    {
      service: "Same Day Delivery",
      description: "Whether it's an important gift or an urgent delivery, our Same Day Delivery service ensures fast, reliable delivery to any location within the day.",
      icon: <FaClipboardCheck className="w-16 h-16 text-black" />,
    },
    {
      service: "Local Delivery Solutions",
      description: "From documents to parcels, we provide local, same-day delivery solutions that are cost-effective and time-efficient.",
      icon: <FaMapMarkerAlt className="w-16 h-16 text-black" />,
    },
  ];

  const handleFAQClick = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);  // Toggle open FAQ
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[700px]"
        style={{ backgroundImage: "url('images/box1.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Domestic Same Day Delivery</h1>
        </div>
      </div>

      {/* Domestic Services Section */}
      <section id="domestic-services" className="py-16 bg-white text-black">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center p-4 xl:px-32">
          {domesticServices.map((service, index) => (
            <div key={index} className="flex flex-col gap-6 items-center text-center p-6 bg-white text-black rounded-xl shadow-lg hover:scale-105 transition-transform duration-300 ease-in-out">
              <div className="mb-4">{service.icon}</div>
              <h3 className="text-xl font-thin mb-2">{service.service}</h3>
              <p className="text-zinc-600 font-thin">{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Additional Content Section */}
      <section className="py-16 px-4 bg-white text-black">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-thin mb-6 text-center">1UKLogistics Services</h2>
          <p className="text-lg mb-4 text-justify p-2 font-thin">
            1UKLogisticss are committed to same day delivery for all households across the UK. We understand that when you need a courier, it is important to have a professional service that you can rely on. Our drivers are experienced and our vehicles are well-maintained, so you can be confident that your delivery will arrive on time and in good condition.
          </p>
          <p className="text-lg mb-4 text-justify p-2 font-thin">
            In addition, our prices are competitive and we offer a range of services to suit your needs. Whether you need an urgent same day delivery or a more flexible service, we can help. Contact us today to find out more about our same day courier services.
          </p>
          <h3 className="text-2xl md:text-4xl font-thin mt-6 mb-4 text-center">Emergency Courier Service for Urgent Needs</h3>
          <p className="text-lg mb-4 text-justify p-2 font-thin" >
            When time is critical, 1UKLogisticss offers an Emergency Courier Service that guarantees same-day delivery across the UK. Whether it’s a time-sensitive package or an urgent replacement part, we’ll collect your item within 60 minutes and deliver it directly to its destination.
          </p>
          <h3 className="text-2xl md:text-4xl font-thin mt-6 mb-4 text-center">Forgotten Passport? We’ve Got You Covered</h3>
          <p className="text-lg mb-4 text-justify p-2 font-thin">
            Forgotten your passport and need it urgently? Our Domestic Same Day Courier Service ensures that forgotten passports are collected and delivered on the same day, getting them to you wherever you are in the UK.
          </p>
          <h3 className="text-2xl md:text-4xl font-thin mt-6 mb-4 text-center">Two-Man Delivery for Larger Items</h3>
          <p className="text-lg mb-4 text-justify p-2 font-thin">
            Need to move bulky or heavy items quickly and securely? Our Domestic Same Day Courier Service includes a reliable two-man delivery option, perfect for handling furniture, large appliances, or delicate oversized items.
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      {/* FAQ Section */}
<section className="md:py-16 bg-white text-black px-4">
  <div className="max-w-3xl mx-auto">
    <h2 className="text-2xl md:text-4xl font-thin mb-12 text-center">Frequently Asked Questions</h2>
    <div className="space-y-4">
      {[
        {
          question: 'How does same-day delivery work?',
          answer: 'Same-day delivery ensures your package is picked up and delivered on the same day. Simply schedule a pickup, and our courier will collect and transport your parcel promptly.'
        },
        {
          question: 'What areas are covered?',
          answer: 'We provide delivery services across major cities and surrounding areas. Please enter your location on our website to check availability in your area.'
        },
        {
          question: 'How do I book a pickup?',
          answer: 'You can book a pickup through our website or mobile app. Select the pickup and delivery locations, choose a time slot, and confirm your order. Our courier will handle the rest!'
        }
      ].map((faq, index) => (
        <div key={index} className="border-b pb-4">
          <div className="flex justify-between items-center cursor-pointer" onClick={() => handleFAQClick(index)}>
            <h4 className="text-xl font-thin">{faq.question}</h4>
            <FaChevronDown className={`transform transition-transform duration-200 ${openFAQ === index ? 'rotate-180' : ''}`} />
          </div>
          {openFAQ === index && (
            <p className="mt-2 text-zinc-500 text-lg font-thin">{faq.answer}</p>
          )}
        </div>
      ))}
    </div>
  </div>
</section>

    </div>
  );
}

export default DomesticSameDayService;
